<template>
    <div class="wrapper">
        <div class="index">
            <div class="info-message">
                Bla om nødvendig for å se alle feltene
            </div>
            <div class="email-chooser" v-if="showEmailChooser">
                Send test e-mail til:
                <br>
                <input type="text" v-model="defaultToEmail" />
            </div>
            <div class="step" v-show="currentStep === 0">
                <div class="buttons">
                    <div class="buttons__left">
                        &nbsp;
                    </div>
                    <!--<div class="buttons__right">
                        <button
                            @click="currentStep = 1;"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>-->
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Kontaktskjema (Norge)
                        </div>
                        <div class="step-counter">
                            &nbsp;
                        </div>
                    </div>
                    <div class="step__description">
                        Her er der en beskrivelse
                    </div>
                </div>
                <!--<div v-if="showDanishAlert" class="danish-alert" style="background: #fff3cd; border: 1px solid #ffc107; padding: 15px; margin-bottom: 20px; border-radius: 4px;">
                    <strong>Er du dansk kunde?</strong><br>
                    <a href="javascript:void(0)" @click="goToDanishForm()" style="color: #856404; font-weight: bold;">
                        Klik her for dansk kontaktformular &rarr;
                    </a>
                    <span @click="showDanishAlert = false" style="float: right; cursor: pointer; color: #856404;">✕</span>
                </div>-->
                <div class="content">
                    Kjære kunde,
                    <br><br>
                    Dette kontaktskjemaet vedlikeholdes ikke lenger.
                    <br><br>
                    Du finner nå all hjelp, veiledning og kontaktalternativer i selvbetjeningen vår.
                    <br><br>
                    <a href="https://selvbetjening.quooker.no?utm_source=qservice&utm_medium=referral&utm_campaign=serviceform" style="color:#C80236;font-family:'AvenirHeavyOblique';" target="_blank">Gå til selvbetjening &rarr;</a>
                </div>
                <div class="buttons">
                    <div class="buttons__left">
                        <button class="swedish-link" @click="goToDanishForm()" style="display:inline-flex;align-items:center;margin-right:10px;">
                            <img src="/static/img/denmark.png" height="16" style="border:1px solid #fff;" />&nbsp;
                            Dansk kunde?
                        </button>
                    </div>
                    <!--<div class="buttons__right">
                        <button
                            @click="currentStep++;"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>-->
                </div>
            </div>
            <div class="step" v-show="currentStep === 1">
                <div class="nordic-chooser" v-if="showCubeErrorcodesModal">
                    <div class="inner" v-if="cubeErrorPage === 1">
                        <div class="title">
                            Handler din forespørsel om CUBE?
                        </div>
                        <div class="choose">
                            <button @click="cubeErrorPage = 2">
                                Ja
                            </button>
                            <button @click="currentStep = 2;showCubeErrorcodesModal = false;">
                                Nei, fortsett
                            </button>
                        </div>
                    </div>
                    <div class="inner" v-if="cubeErrorPage === 2">
                        <div class="title">
                            Viser CUBE en av følgende feilkoder?
                        </div>
                        <div class="text">
                            Trykk på feilkoden nedenfor. Hvis du ikke ser en feilkode, kan du bare fortsette.
                        </div>
                        <div class="text" style="padding:15px 0;">
                            <button v-for="errorcode in cubeErrorcodes" @click="cubeErrorPage = 3;selectedCubeErrorcode = errorcode;$store.state.form.problem.description = `CUBE fejlkode ${errorcode.code} - ${errorcode.description}`" style="width:unset;margin:0 5px;">
                                {{ errorcode.code }}
                            </button>
                        </div>
                        <div class="choose">
                            <button @click="currentStep = 2;showCubeErrorcodesModal = false;">
                                Nei, fortsett
                            </button>
                        </div>
                    </div>
                    <div class="inner" v-if="cubeErrorPage === 3 && selectedCubeErrorcode">
                        <div class="title">
                            CUBE feilkode {{ selectedCubeErrorcode.code }}
                        </div>
                        <div class="text">
                            <!--{{ selectedCubeErrorcode.title }}
                            <br><br>-->
                            {{ selectedCubeErrorcode.description }}
                            <br><br>
                            <b style="color:#C80236;">Mulig løsning</b><br>
                            {{ selectedCubeErrorcode.solution }}
                        </div>
                        <div class="choose">
                            <button @click="currentStep++;showCubeErrorcodesModal = false;cubeErrorPage = 1">
                                Fortsett
                            </button>
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <div class="buttons__left">
                        &nbsp;
                    </div>
                    <div class="buttons__right">
                        <span v-if="$store.state.form.container.serial && $store.state.form.container.serial.length < 6 || $store.state.form.validatedContainer === null || $store.state.form.faucet.serial === null || $store.state.form.faucet.serial === ''">
                            Fyll ut alle feltene merket med "<span class="red-star">*</span>" for å fortsette
                        </span>
                        <button
                            :disabled="$store.state.form.container.serial && $store.state.form.container.serial.length < 6 || $store.state.form.validatedContainer === null || $store.state.form.faucet.serial === null || $store.state.form.faucet.serial === ''"
                            @click="($store.state.form.cube.serial ? (showCubeErrorcodesModal = true) : currentStep = 2)"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Angi serienummer
                        </div>
                        <div class="step-counter">
                            1 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Her er der en beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="line">
                        <div class="left">
                            <label>
                                Serienummer på din beholder <span class="red-star">*</span>
                            </label>
                            <a href="javascript:void(0)" @click="showSerialHelper = !showSerialHelper">
                                Slik finner du serienummeret
                            </a>
                            <div class="nordic-chooser" v-show="showSerialHelper">
                                <div class="inner" align="center">
                                    <h4>Slik finner du serienummeret</h4>
                                    <br>
                                    <img src="static/img/serienummer-beholder.png" style="width:100%;max-height:240px;object-fit:contain;" />
                                    <br><br>
                                    <button @click="showSerialHelper = false">
                                        Lukk
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <input type="text" class="form-control upc" v-model="$store.state.form.container.serial" @keyup="validateSerial()"/>
                            <div class="mts">
                                <span class="green" v-if="$store.state.form.validatedContainer !== null && $store.state.form.container.serial.length > 5">
                                    {{ $store.state.form.validatedContainer.name }}
                                </span>
                                <span v-else>
                                    <span class="red" v-if="$store.state.form.container.serial && $store.state.form.container.serial.length > 0">
                                        {{ faucetSerial ? 'Det ser ut som om du er i ferd med å legge inn serienummeret til kranen, og ikke beholderen din. Vennligst tast inn serienummeret til beholderen din i dette feltet for å fortsette.' : 'Ingen treff funnet' }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <div class="left">
                            <label>
                                Serienummer på din kran <span class="red-star">*</span>
                            </label>
                            Du finner serienummeret på den sorte ledningen fra armaturet.
                            <a href="javascript:void(0)" @click="showTapSerialHelper = !showTapSerialHelper">Slik finner du serienummeret</a>.
                            <div class="nordic-chooser" v-show="showTapSerialHelper">
                                <div class="inner" align="center">
                                    <h4>Sådan finder du dit serienummer</h4>
                                    <br>
                                    <img src="static/img/serienummer-hane.png" style="max-height:240px;width:100%;object-fit:contain;" />
                                    <br><br>
                                    <button @click="showTapSerialHelper = false">
                                        Luk
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <input type="text" class="form-control upc" v-model="$store.state.form.faucet.serial" />
                        </div>
                    </div>
                    <div class="line">
                        <div class="left">
                            <label>
                                Serienummer på din CUBE
                            </label>
                            Hvis du har en CUBE kjøleenhet. Finn serienummeret på klistremerket på fremsiden, rett nedenfor touch displayet.
                            <a href="javascript:void(0)" @click="showCubeSerialHelper = !showCubeSerialHelper">Slik finner du serienummeret</a>.
                            <div class="nordic-chooser" v-show="showCubeSerialHelper">
                                <div class="inner" align="center">
                                    <h4>Sådan finder du dit serienummer</h4>
                                    <br>
                                    <img src="static/img/serienummer-cube.png" style="max-height:240px;width:100%;object-fit:contain;" />
                                    <br><br>
                                    <button @click="showCubeSerialHelper = false">
                                        Luk
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <input type="text" class="form-control upc" v-model="$store.state.form.cube.serial" />
                        </div>
                    </div>
                    <!--<div class="line">
                        <div class="left">
                            <label>
                                Har du en CUBE?
                            </label>
                            Har du en Quooker CUBE drikkevandskøler installeret?
                        </div>
                        <div class="right flex">
                            <button @click="$store.state.form.cube.own = true" :class="{'selected': $store.state.form.cube.own === true}">
                                Ja
                            </button>
                            <button @click="$store.state.form.cube.own = false" :class="{'selected': $store.state.form.cube.own === false}">
                                Nei
                            </button>
                        </div>
                    </div>
                    <div class="line" v-if="$store.state.form.cube.own">
                        <div class="left">
                            <label>
                                Serienummer på CUBE
                            </label>
                            Serienummeret finder du på bagsiden af CUBE eller på den medfølgende installationsvejledning.
                        </div>
                        <div class="right">
                            <input type="text" class="form-control" v-model="$store.state.form.cube.serial" />    
                        </div>
                    </div>-->
                </div>
            </div>
            <div class="step" v-show="currentStep === 2">
                <div class="nordic-chooser" v-if="showNordicChooser">
                    <div class="inner">
                        <div class="title">
                            Twintaps eller single tap Nordic?
                        </div>
                        <div class="text">
                            Twintaps består av både en kokende vannkran og et separat blandingsbatteri fra Quooker.
                            Single tap er når du kun har en kokende vannkran fra Quooker.
                        </div>
                        <div class="choose">
                            <button @click="chooseNordic('Twintaps')">
                                Twintaps
                            </button>
                            <button @click="chooseNordic('Single Tap')">
                                Single tap
                            </button>
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 1">
                            <i class="fal fa-chevron-left" />
                            Tilbake
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            :disabled="$store.state.form.validatedFaucet === null"
                            @click="currentStep = 3"
                        >
                            <span v-if="$store.state.form.validatedFaucet === null">
                                Kran må velges
                            </span>
                            <span v-else>
                                Videre
                            </span>
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Velg kran
                        </div>
                        <div class="step-counter">
                            2 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="faucets">
                        <div
                            class="faucet"
                            v-for="faucet in sortedFaucets"
                            v-bind:key="faucet.title"
                            @click="validateFaucet(faucet)"
                            :class="{'selected': $store.state.form.validatedFaucet !== null && $store.state.form.validatedFaucet.title === faucet.title}"
                        >
                            <div class="image">
                                <img :src="faucet.image" />
                            </div>
                            <div class="title">
                                {{ faucet.title }}
                            </div>
                            <div class="description">
                                {{ faucet.description }}
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
            <div class="step" v-show="currentStep === 3">
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 2">
                            <i class="fal fa-chevron-left" />
                            Tilbake
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            :disabled="$store.state.form.faucet.surface === null"
                            @click="currentStep = 4"
                        >
                            <span v-if="$store.state.form.faucet.surface === null">
                                Overflate må velges
                            </span>
                            <span v-else>
                                Videre
                            </span>
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Velg overflate
                        </div>
                        <div class="step-counter">
                            3 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="surfaces">
                        <div
                            class="surface"
                            v-for="surface in sortedSurfaces"
                            v-bind:key="surface.title"
                            @click="$store.state.form.faucet.surface = surface.title"
                            :class="{'selected': $store.state.form.faucet.surface === surface.title}"
                        >
                            <div class="image">
                                <img class="sm" :src="surface.image" />
                            </div>
                            <div class="title">
                                {{ surface.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step" v-show="currentStep === 4">

                <div class="nordic-chooser" v-if="showRestartHelper">
                    <div class="inner">
                        <div class="close" @click="showRestartHelper = false">
                            X
                        </div>
                        <h4>
                            Slik starter du Quooker på nytt
                        </h4>
                        Mange feil kan vellykkes, med en enkel omstart og tilbakestilling av Quooker-programvaren.
                        <a href="https://quooker.no/faq-generelt" rel="noopener" target="_blank">
                            Slik starter du Quooker på nytt</a>.
                        <br><br>
                        Det er ikke nok bare å koble fra!
                        <br><br>
                        Vi anbefaler at du prøver å starte Quooker på riktig måte noen ganger før du kontakter oss.
                        <br><br>
                        <div class="option" @click="showRestartHelper = false">
                            Lukk vinduet
                        </div>
                    </div>
                </div>
                <div class="nordic-chooser" v-if="showBlinkHelper">
                    <div class="inner">
                        <div class="close" @click="showBlinkHelper = false; $store.state.form.problem.questions[2].answer = null">
                            X
                        </div>
                        <h4>
                            Hvordan blinker Quooker-kranen?
                        </h4>
                        Hvis din Quooker oppdager en feil/uregelmessighet vil lyset på kranen og beholderen blinke i et fast mønster.
                        <br><br>
                        <b style="font-size:90%;">OBS! I enkelte tilfelle er det kun beholderen som blinker, derfor er det viktig å sjekke både kranen og beholderen.</b>
                        <br><br>
                        <div class="option-wrapper">
                            <div class="option fl" @click="$store.state.form.problem.questions[2].extra = '2 blink'; showBlinkHelper = false">
                                <div class="blink two">
                                    <div class="blink__title">
                                        2 blink
                                    </div>                                            
                                    <img src="/static/gif/blinktwo.gif" />
                                </div>
                            </div>
                            <div class="option fl" @click="$store.state.form.problem.questions[2].extra = '4 blink'; showBlinkHelper = false; show4BlinkHelper = true">
                                <div class="blink four">
                                    <div class="blink__title">
                                        4 blink
                                    </div>
                                    <img src="/static/gif/blinkfour.gif" />
                                </div>
                            </div>
                            <div class="option fl" @click="$store.state.form.problem.questions[2].extra = '3 + 1 blink'; showBlinkHelper = false">
                                <div class="blink threeplusone">
                                    <div class="blink__title">
                                        3 + 1 blink
                                    </div> 
                                    <img src="/static/gif/blinkthreeplusone.gif" />
                                </div>
                            </div>
                        </div>
                        <div align="center">
                            <div class="option last" @click="$store.state.form.problem.questions[2].extra = 'Andet / ved ikke'; showBlinkHelper = false">
                                Annet /vet ikke
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nordic-chooser" v-if="show4BlinkHelper">
                    <div class="inner" style="max-height:90%;overflow-y:scroll;">
                        <div class="close" @click="show4BlinkHelper = false">
                            X
                        </div>
                        <h4>
                            4 blink
                        </h4>
                        4 raske blink på kran eller beholder, betyr at softwaren i din Quooker registrerer en feil i forbindelse med temperaturmålingen i din Quooker.
                        <br><br>
                        <b style="color:#C80236;">Tips!</b><br>
                        Feilen kan ofte nullstilles, ved å gi beholderen et såkalt «kuldesjokk».<br><br>
                        Dette gjøres ved å slå av beholderen på beholderens topp, og tappe ut alt kokende vann i beholderen. Når vannet ikke lender er kokende, lar man vannet renne i ytterligere 2 minutter, slik at vi forsikrer oss om at vannet er helt kaldt.<br><br>
                        Deretter skal du følge vår alminnelige <a href="https://quooker.dk/service/fejlguide/genstart-nulstil" target="_blank" class="main">restartsprosedyre</a>, og beholderen burde være klar til bruk etter ca. 20 minutter.<br><br>
                        Det kan være nødvendig å gjenta denne prosedyren et par ganger.<br><br>
                        <button style="width:unset;outline:none;background:#C80236;color:#fff;border:1px solid #e6003f!important;padding:5px 10px;white-space:nowrap;" @click="show4BlinkHelper = false">
                            OK, jeg prøver!
                        </button>
                    </div>
                </div>

                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 3">
                            <i class="fal fa-chevron-left" />
                            Tilbake
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            :disabled="$store.state.form.problem.questions[0].answer === null || $v.$store.state.form.problem.$invalid || $store.state.form.problem.questions[1].answer === null || $store.state.form.problem.questions[2].answer === null || $store.state.form.problem.description === null"
                            @click="currentStep = 5"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Problem / årsak
                        </div>
                        <div class="step-counter">
                            4 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div
                        class="line"
                        v-for="(question, index) in $store.state.form.problem.questions" v-bind:key="question.question"
                        style="margin-bottom:15px;"
                    >
                        <div class="left">
                            <label>
                                {{ question.questionNO }}
                            </label>
                            <div v-if="question.slug === 'restart'">
                                <a href="https://quooker.no/faq-generelt" rel="noopener" target="_blank">
                                    <i class="fal fa-info-circle fa-fw" />
                                    Slik tilbakestiller du din Quooker
                                </a>
                            </div>
                        </div>
                        <div class="right flex" v-if="index === 2">
                            <button
                                @click="$store.state.form.problem.questions[index].answer = true; showBlinkHelper = true"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === true}"
                            >
                                Ja
                            </button>
                            <button
                                @click="$store.state.form.problem.questions[index].answer = false; $store.state.form.problem.questions[index].extra = null"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === false}"
                            >
                                Nei
                            </button>
                        </div>
                        <div class="right flex" v-else-if="index === 3">
                            <button
                                @click="$store.state.form.problem.questions[index].answer = true"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === true}"
                            >
                                Ja
                            </button>
                            <button
                                @click="$store.state.form.problem.questions[index].answer = false; showRestartHelper = true"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === false}"
                            >
                                Nei
                            </button>
                        </div>
                        <div class="right flex" v-else>
                            <button
                                @click="$store.state.form.problem.questions[index].answer = true"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === true}"
                            >
                                Ja
                            </button>
                            <button
                                @click="$store.state.form.problem.questions[index].answer = false"
                                :class="{'selected': $store.state.form.problem.questions[index].answer === false}"
                            >
                                Nei
                            </button>
                        </div>
                    </div>
                    <div class="line">
                        <div class="left">
                            <label>
                                Beskriv problemet
                            </label>
                            Beskriv problemet eller spørsmålet i feltet her. Ved feil er det viktig å forklare symptomet. Hva gjør du og hva skjer?
                        </div>
                        <div class="right">
                            <textarea class="form-control" placeholder="Beskrivelse av problem" rows="4" v-model="$store.state.form.problem.description" />
                            <div class="flex-wrapper mts">
                                <validation-messages :data="$v.$store.state.form.problem.description" :show="true" />    
                                <div class="validator" v-if="$store.state.form.problem.description" :class="{'validated': $store.state.form.problem.description.length > 19}">
                                    {{ $store.state.form.problem.description.length }} / 20
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step" v-show="currentStep === 5">
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 4">
                            <i class="fal fa-chevron-left" />
                            Tilbake
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            :disabled="$store.state.form.warranty.underWarranty === null || $store.state.form.warranty.underWarranty === true && $store.state.form.warranty.installationMonth === null || $store.state.form.warranty.underWarranty === true && $store.state.form.warranty.installationYear === null"
                            @click="currentStep = 6"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Garanti
                        </div>
                        <div class="step-counter">
                            5 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="line">
                        <div class="left">
                            <label>
                                Er produktet under 24 måneder?
                            </label>
                        </div>
                        <div class="right flex">
                            <button
                                @click="$store.state.form.warranty.underWarranty = true"
                                :class="{'selected': $store.state.form.warranty.underWarranty === true}"
                            >
                                Ja
                            </button>
                            <button
                                @click="$store.state.form.warranty.underWarranty = false"
                                :class="{'selected': $store.state.form.warranty.underWarranty === false}"
                            >
                                Nei
                            </button>
                        </div>
                    </div>
                    <div class="line" v-if="$store.state.form.warranty.underWarranty === true">
                        <div class="left">
                            <label>
                                Installasjonsdato
                            </label>
                            Velg måned og år for installasjon
                        </div>
                        <div class="right flex">
                            <select class="form-control" v-model="$store.state.form.warranty.installationMonth">
                                <option v-for="month in months" v-bind:key="month">
                                    {{ month }}
                                </option>
                            </select>
                            <select class="form-control" v-model="$store.state.form.warranty.installationYear">
                                <option v-for="year in years" v-bind:key="year">
                                    {{ year }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step" v-show="currentStep === 6">
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 5">
                            <i class="fal fa-chevron-left" />
                            Tilbage
                        </button>
                    </div>
                    <div class="buttons__right">
                        <button
                            @click="currentStep = 7"
                        >
                            Videre
                            <i class="fal fa-chevron-right" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Vedhæft filer
                        </div>
                        <div class="step-counter">
                            6 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <file-upload
                        intro="Valgfritt - Last opp bilder, video eller andre relevante filer hvis du har blitt bedt om det<br><br><b style='font-family:AvenirHeavyOblique;'>OBS</b>&nbsp;&nbsp;Hvis Quooker din har lyder, vil vi be om en video<br><b style='font-family:AvenirHeavyOblique;color:#fff;'>OBS</b>&nbsp;&nbsp;Hvis Quooker din har blitt fysisk skadet, ber vi om bilder"
                        singleFileUploaded="fil lastet opp"
                        multipleFilesUploaded="filer lastet opp"
                        noFilesUploaded="Ingen filer lastet opp"
                        addFilesButton="Legg til fil(er)"
                        remove="Fjern"
                    />
                </div>
            </div>
            <div class="step" v-show="currentStep === 7">
                <div id="emailMockup" style="display:none;position:absolute;z-index:999;background:#f8f9fc;width:100%;" v-if="currentStep === 7">
                    <div style="max-width:100%;width:400px;margin: 25px auto;">
                        <div class="intro">
                            <div v-html="$store.state.texts.norwegian" style="white-space:pre-wrap;" />
                            <br>
                            <b>Viktig!</b> Hvis du har spørsmål, vennligst besvar denne mail.
                            <br><br>
                            Nedenfor finner du en kopi av dine inntastede opplysninger.
                            <br><br>
                        </div>
                        <div class="summary" style="background:#fff;padding:30px;border:1px solid #ccc;">
                            <div>
                                <b>Saksnummer</b>
                                <br>
                                {{ $store.state.form.meta.id }}
                            </div>
                            <br>
                            <div>
                                <b>Beholder</b>
                                <br>
                                <span v-if="$store.state.form.container.serial !== null">
                                    {{ $store.state.form.container.serial.toUpperCase() }} - {{ $store.state.form.validatedContainer.name }}
                                </span>
                            </div>
                            <br>
                            <div v-if="$store.state.form.cube.serial !== null">
                                <b>CUBE</b>
                                <br>
                                Serienummer: {{ $store.state.form.cube.serial }}
                            </div>
                            <br v-if="$store.state.form.cube.serial !== null">
                            <div>
                                <b>Kran</b>
                                <br>
                                {{ $store.state.form.validatedFaucet.title }}
                                <span v-if="$store.state.form.faucet.meta !== null">
                                    ({{ $store.state.form.faucet.meta }})
                                </span>
                                <span>
                                    <br>
                                    {{ $store.state.form.faucet.surface }}
                                </span>
                                <span v-if="$store.state.form.faucet.serial !== null">
                                    <br>
                                    {{ $store.state.form.faucet.serial }}
                                </span>
                            </div>
                            <br>
                            <div>
                                <b>Spørsmål</b>
                                <br>
                                <div v-for="q in $store.state.form.problem.questions">
                                    {{ q.questionNO }}:
                                    <b v-if="q.answer">
                                        Ja
                                    </b>
                                    <b v-else>Nei</b>
                                    <b v-if="q.extra">
                                        ({{ q.extra }})
                                    </b>
                                </div>
                            </div>
                            <br>
                            <div>
                                <b>Beskrivelse av problem</b>
                                <br>
                                {{ $store.state.form.problem.description }}
                            </div>
                            <br>
                            <div>
                                <b>Garanti</b>
                                <br>
                                Er produktet under 24 måneder?
                                <b v-if="$store.state.form.warranty.underWarranty">Ja</b>
                                <b v-else>Nei</b>
                                <br>
                                <span v-if="$store.state.form.warranty.underWarranty">
                                    Installasjonsdato:
                                    <b>{{ $store.state.form.warranty.installationMonth }} {{ $store.state.form.warranty.installationYear }}</b>
                                </span>
                            </div>
                            <br>
                            <div>
                                <b>Kontaktinformasjon</b>
                                <br>
                                {{ $store.state.form.contact.firstname }}
                                {{ $store.state.form.contact.lastname }}
                                <br>
                                <span v-if="$store.state.form.contact.company !== null">
                                    Firma: {{ $store.state.form.contact.company }}
                                </span>
                                <br v-if="$store.state.form.contact.company !== null">
                                {{ $store.state.form.contact.phone }}
                                <br>
                                {{ $store.state.form.contact.email }}
                                <br>
                                <div v-if="fullAddress !== null">
                                    {{ fullAddress }}
                                </div>
                            </div>
                            <br>
                            <div>
                                <b>Vedlegg</b>
                                <br>
                                <div v-if="$store.state.form.attachments.length > 0">
                                    <ul>
                                        <li v-for="attachment in $store.state.form.attachments" v-bind:key="attachment.name">
                                            <a :href="attachment.path">
                                                {{ attachment.name }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>
                                    Ingen filer lastet opp
                                </div>
                            </div>
                        </div>
                        <div class="outro" align="center">
                            <br><br>
                            Med vennlig hilsen
                            <br>
                            <b>Quooker Norge AS</b>
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <div class="buttons__left">
                        <button @click="currentStep = 6">
                            <i class="fal fa-chevron-left" />
                            Tilbake
                        </button>
                    </div>
                    <div class="buttons__right">
                        <span v-if="loading">
                            <i class="fal fa-spinner fa-spin" />
                            &nbsp;
                        </span>
                        <button
                            :disabled="loading || $v.$store.state.form.contact.$invalid || $store.state.form.terms.accepted === false"
                            @click="submitForm()"
                        >
                            Send
                            <i class="fal fa-envelope" />
                        </button>
                    </div>
                </div>
                <div class="header">
                    <div class="step__title">
                        <div>
                            Kontaktinformasjon
                        </div>
                        <div class="step-counter">
                            6 / 7
                        </div>
                    </div>
                    <div class="step__description">
                        Step beskrivelse
                    </div>
                </div>
                <div class="content">
                    <div class="line three-columns">
                        <div class="left">
                            <label>
                                Fornavn <span class="red-star">*</span>
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.firstname" />
                            <validation-messages class="mts" :data="$v.$store.state.form.contact.firstname" />
                        </div>
                        <div class="left middle">
                            <label>
                                Etternavn <span class="red-star">*</span>
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.lastname" />
                            <validation-messages class="mts" :data="$v.$store.state.form.contact.lastname" />
                        </div>
                        <div class="left">
                            <label>
                                Firma (valgfri)
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.company" />
                        </div>
                    </div>
                    <div class="line">
                        <div class="left">
                            <label>
                                E-post <span class="red-star">*</span>
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.email" />
                            <validation-messages class="mts" :data="$v.$store.state.form.contact.email" />
                        </div>
                        <div class="right">
                            <label>
                                Telefon <span class="red-star">*</span>
                            </label>
                            <input type="text" class="form-control" v-model="$store.state.form.contact.phone" />
                            <validation-messages class="mts" :data="$v.$store.state.form.contact.phone" />
                        </div>
                    </div>
                    <!--<div class="line">
                        <div class="left fw autocomplete-container">
                            <label>
                                Adresse *
                            </label>
                            <label style="display:none!important;">
                                A
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="$store.state.form.contact.validatedAddress"
                                name="2f3b92h83nfuiei9h"
                                autocomplete="new-password"
                            />
                            <validation-messages class="mts" :data="$v.$store.state.form.contact.validatedAddress" />
                        </div>
                    </div>-->
                    <div class="line address-field">
                        <div class="row" style="width:calc(100% + 30px);">
                            <div class="col-lg-6 col-sm-6">
                                <label>
                                    Adresse <span class="red-star">*</span>
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="address"
                                    name="2f3b92h83nfuiei9he"
                                    autocomplete="new-password"
                                />
                                <!--<validation-messages class="mts" :data="$v.address" />-->
                            </div>
                            <div class="col-lg-2 col-sm-2">
                                <label>
                                    Postnr. <span class="red-star">*</span>
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="zipcode"
                                />
                                <!--<validation-messages class="mts" :data="$v.zipcode" />-->
                            </div>
                            <div class="col-lg-4 col-sm-4">
                                <label>
                                    By <span class="red-star">*</span>
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="city"
                                />
                                <!--<validation-messages class="mts" :data="$v.city" />-->
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <div class="left fw terms">
                            <input type="checkbox" v-model="$store.state.form.terms.accepted" />
                            <div>
                                Jeg har lest og akseptert Quookers <a href="https://quooker.dk/privatlivspolitik" rel="noopener" target="_blank">privatlivs- og forretningsbetingelser</a> <span class="red-star">*</span>
                            </div>
                        </div>
                        <div class="right">

                        </div>
                    </div>
                </div>
            </div>
            <div class="step" v-if="currentStep === 8">
                <div class="header">
                    <div class="step__title">
                        <div>
                            INNSENDT - Takk for din henvendelse
                        </div>
                    </div>
                </div>
                <div class="content" style="font-size:1.2em;">
                    <div v-html="$store.state.texts.norwegian" style="white-space:pre-wrap;" />
                    <br>
                    Saksnummer: <b>{{ $store.state.form.meta.id }}</b>
                    <br><br>
                    Vi har sendt deg en e-post hvor saksnummeret ditt er notert. Hvis du ikke mottar denne e-post i løpet av en time, bør du sjekke om den har havnet som søppelpost. Hvis den heller ikke er der, ber vi deg kontakte oss på telefon.
                </div>
            </div>
        </div>
        <div class="q-progress-bar" v-if="currentStep !== 7">
            <div class="line" :style="'width:' + ((16.66 * currentStep) - 16.66) + '%;'" />
            <div class="q-progress-bar__step" :class="{'active': currentStep === 1}">
                1
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 2}">
                2
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 3}">
                3
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 4}">
                4
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 5}">
                5
            </div>
            <div class="q-progress-bar__step" :class="{'active': currentStep === 6}">
                6
            </div>
        </div>
        <!--<br>
        <div class="store">
            <ul>
                <li v-for="(item, key) in $store.state.form" style="margin:20px 0;">
                    {{ key }}:
                    <ul>
                        <li v-for="(subItem, key) in item">
                            {{ key }}: {{ subItem }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>-->
    </div>
</template>

<style lang="scss">
@import '../../styles/main.scss';
</style>

<script>
import { required, minLength, email, maxLength } from 'vuelidate/lib/validators'
import ValidationMessages from '@/components/validation/validationMessagesNO'
import FileUpload from '@/components/elements/file-upload'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import axios from 'axios'

export default {
    data () {
        return {
            showDanishAlert: false,
            faucetSerial: false,
            address: null,
            zipcode: null,
            city: null,
            loading: false,
            showSerialHelper: false,
            showTapSerialHelper: false,
            showCubeSerialHelper: false,
            showBlinkHelper: false,
            show4BlinkHelper: false,
            showRestartHelper: false,
            currentStep: 0,
            showNordicChooser: false,
            showCubeErrorcodesModal: false,
            cubeErrorPage: 1,
            selectedCubeErrorcode: null,
            cubeErrorcodes: [
                {
                    code: 'E1',
                    title: 'Ventilator defekt/ventilator sitter fast/ventilator ikke tilkoblet',
                    description: 'Ventilatoren virker ikke',
                    solution: 'Prøv å rengjøre ventilatoren med en børste eller støvsuger. Hvis problemet vedvarer, bare gå videre.',
                    icon: false
                },
                {
                    code: 'E2',
                    title: 'Utilstrekkelig kjølemiddel / feil plassering av temperatursensor',
                    description: 'Utilstrekkelig kjøling',
                    solution: 'Trykk på gjenstartsikonet på displayet. Hvis problemet vedvarer, bare gå videre.',
                    icon: true
                },
                {
                    code: 'E3',
                    title: 'Pumpen virker ikke; ingen vannforsyning / for mye luft i systemet / høydesensor ikke tilkoblet',
                    description: 'Beholderen med kullsyrevann er ikke fyllt opp',
                    solution: 'Kontrollér at avsperringsventilen er åpen (kontraintuitivt). Undersøk at slangene ikke er bøyde. Trykk på gjenstartsikonet på displayet. Hvis problemet vedvarer, bare gå videre.',
                    icon: true
                },
                {
                    code: 'E4',
                    title: 'Lekkasje eller kondens',
                    description: 'For mye vann i dryppbrett',
                    solution: 'Kontakt oss ved å fylle ut dette skjemaet.',
                    icon: false
                },
                {
                    code: 'E9',
                    title: 'Vannforsyningen er ikke tilkoblet under oppstartsprosessen',
                    description: 'Pumpens hastighet er for høy under oppstartsprosessen',
                    solution: 'Kontrollér at avsperringsventilen er åpen (kontraintuitivt). Undersøk at slangene ikke er bøyde. Hvis problemet vedvarer, bare gå videre.',
                    icon: false
                }
            ],
            defaultToEmail: 'service@quooker.no',
            faucets: [
                {
                    title: 'Front',
                    type: 'front',
                    description: 'Kaldt, varmt og kokende vann',
                    image: 'static/img/front-2.png'
                },
                {
                    title: 'Fusion Round',
                    type: 'fusion',
                    description: 'Kaldt, varmt og kokende vann',
                    image: 'static/img/Fusion_Round_krom-1.png'
                },
                {
                    title: 'Fusion Square',
                    type: 'fusion',
                    description: 'Kaldt, varmt og kokende vann',
                    image: 'static/img/Fusion-Square-krom-kopi.png'
                },
                {
                    title: 'Nordic Round',
                    type: 'nordic',
                    description: 'Kokende vann',
                    image: 'static/img/Nordic_round.png'
                },
                {
                    title: 'Nordic Square',
                    type: 'nordic',
                    description: 'Kokende vann',
                    image: 'static/img/Nordic_square.png'
                },
                {
                    title: 'Flex',
                    type: 'flex',
                    description: 'Kaldt, varmt og kokende vann og uttrekksslange',
                    image: 'static/img/flex.png'
                },
                {
                    title: 'Classic Fusion Round',
                    type: 'cl-fusion',
                    description: 'Kaldt, varmt og kokende vann',
                    image: 'static/img/Classic_Fusion_Round_krom.png'
                },
                {
                    title: 'Classic Fusion Square',
                    type: 'cl-fusion',
                    description: 'Kaldt, varmt og kokende vann',
                    image: 'static/img/Classic_Fusion_Square_krom.png'
                },
                {
                    title: 'Classic Nordic Round',
                    type: 'cl-nordic',
                    description: 'Kokende vann',
                    image: 'static/img/Classic_Nordic_Round_krom.png'
                },
                {
                    title: 'Classic Nordic Square',
                    type: 'cl-nordic',
                    description: 'Kokende vann',
                    image: 'static/img/Classic_Nordic_Square_krom.png'
                },
                {
                    title: 'Modern',
                    type: 'classic',
                    description: 'Kokende vann',
                    image: 'static/img/modern.png'
                },
                {
                    title: 'Classic',
                    type: 'classic',
                    description: 'Kokende vann',
                    image: 'static/img/classic.png'
                },
                {
                    title: 'Basic',
                    type: 'classic',
                    description: 'Kokende vann',
                    image: 'static/img/Basic.png'
                },
                {
                    title: 'Design',
                    type: 'classic',
                    description: 'Kokende vann',
                    image: 'static/img/design.png'
                }
            ],
            surfaces: [
                {
                    title: 'Krom',
                    fits: 'flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                    image: 'static/img/overflade_krom-e1515075015591.png'
                },
                {
                    title: 'Børstet krom',
                    fits: 'nordic,fusion,classic',
                    image: 'static/img/borstet_krom-e1515075356409.png'
                },
                {
                    title: 'Rustfritt stål',
                    fits: 'front,nordic,fusion,flex,cl-fusion,cl-nordic',
                    image: 'static/img/rustfrit_staal-e1515074931468.png'
                },
                {
                    title: 'Black',
                    fits: 'front,fusion,flex',
                    image: 'static/img/sort-e1515075215324.png'
                },
                {
                    title: 'Messing',
                    fits: 'nordic,fusion',
                    image: 'static/img/messing-e1515075074718.png'
                },
                {
                    title: 'Aldret messing',
                    fits: 'nordic,fusion,cl-fusion',
                    image: 'static/img/bruneret_messing-e1515075086176.png'
                },
                {
                    title: 'Gull',
                    fits: 'fusion,classic',
                    image: 'static/img/guld-1-e1515075138363.png'
                },
                {
                    title: 'Rustfritt stål look',
                    fits: 'classic',
                    image: 'static/img/rustfrit_staal-e1515074931468.png'
                },
                {
                    title: 'Rose copper',
                    fits: 'front,flex,fusion',
                    image: 'static/img/rose-copper.png'
                },
                {
                    title: 'Gunmetal',
                    fits: 'front,flex,fusion',
                    image: 'static/img/gunmetal.png'
                },
                {
                    title: 'Vet ikke',
                    fits: 'front,flex,nordic,fusion,classic,cl-fusion,cl-nordic',
                    image: 'static/img/ved_ikke-e1515075230382.png'
                }
            ],
            months: [
                'Januar',
                'Februar',
                'Mars',
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Desember'
            ],
            serials: [
                // 3 litres
                { identifier: 'VC3', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: 3127770, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' },
                { identifier: 'VCE3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: 307235, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' },
                { identifier: 'VCF3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399002, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VCD3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399003, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VCW3', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBF3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBD3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399006, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBW3', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBW4', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBW5', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VBW6', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                // 7 litres
                { identifier: 'VC5', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' },
                { identifier: 'VCE5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' },
                { identifier: 'VCF5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' },
                { identifier: 'VCD5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VCW5', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                // 7 litres (Quookers own serial numbers) - Same as above but with 7 instead of 5
                { identifier: 'VC7', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: 518827, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'classic' },
                { identifier: 'VCE7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: 599999, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,cl-nordic' },
                { identifier: 'VCF7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599002, swopUrl: 'swop-pro7-vaq-e', breakpoint: 500089, servicekitNo: 10000, servicekitLink: 'servicekit-pro3-pro7', taps: 'nordic,fusion,cl-fusion' },
                { identifier: 'VCD7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599003, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'VCW7', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                // Combi
                { identifier: 'CC4', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 434060, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' },
                { identifier: 'CP4', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: 419403, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'classic' },
                { identifier: 'CCE4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' },
                { identifier: 'CPE4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: 499999, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,cl-nordic' },
                { identifier: 'CCF4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 403873, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPF4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499004, swopUrl: 'swop-combi-2-2-e', breakpoint: 404361, servicekitNo: 10005, servicekitLink: 'servicekit-combi', taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCD4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPD4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499006, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCW4', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPW4', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CC5', name: 'COMBI 3.0', slug: 'combi-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' },
                { identifier: 'CP5', name: 'COMBI+ 3.0', slug: 'combi-plus-3', swopNo: 699004, swopUrl: 'x', breakpoint: null, taps: 'classic' },
                { identifier: 'CCF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' },
                { identifier: 'CPF5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699005, swopUrl: 'x', breakpoint: null, taps: 'nordic,cl-nordic' },
                { identifier: 'CPE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCE5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699006, swopUrl: 'x', breakpoint: null, taps: 'nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCD5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699007, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CPW6', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'CCW5', name: 'COMBI 3.0 E', slug: 'combi-3-e', swopNo: 699008, swopUrl: 'x', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                // New serial numbers 2021 (starting with "R")
                { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399004, swopUrl: 'swop-vcd3-vcw3', breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399007, swopUrl: 'swop-vbd3-vbw3-vbw4', breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RCE', name: 'Combi 2.2 E', slug: 'combi-2-2-e', swopNo: 499008, swopUrl: 'swop-ccd-cpd-ccw-cpw', breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599004, swopUrl: 'swop-vcd5-vcw5', breakpoint: null, taps: 'front,flex,nordic,fusion' },
                // NEW START
                { identifier: 'RVR', name: 'PRO3-VAQ', slug: 'pro3-vaq', swopNo: 399000, swopUrl: 'swop-pro3-vaq', breakpoint: null, taps: 'classic' },
                { identifier: 'RVE', name: 'PRO3-VAQ E', slug: 'pro3-vaq-e', swopNo: 399001, swopUrl: 'swop-pro3-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RVB', name: 'PRO3-VAQ B', slug: 'pro3-vaq-b', swopNo: 399005, swopUrl: 'swop-pro3-vaq-b', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RZR', name: 'PRO7-VAQ', slug: 'pro7-vaq', swopNo: 599000, swopUrl: 'swop-pro7-vaq', breakpoint: null, taps: 'classic' },
                { identifier: 'RZE', name: 'PRO7-VAQ E', slug: 'pro7-vaq-e', swopNo: 599001, swopUrl: 'swop-pro7-vaq-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RZB', name: 'PRO7-VAQ B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RCR', name: 'COMBI 2.2', slug: 'combi-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' },
                { identifier: 'RCE', name: 'COMBI 2.2 E', slug: 'combi-2-2-e', swopNo: 499002, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RCB', name: 'COMBI 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' },
                { identifier: 'RPR', name: 'COMBI+ 2.2', slug: 'combi-2-2-2', swopNo: 499000, swopUrl: 'swop-combi-2-2', breakpoint: null, taps: 'classic' },
                { identifier: 'RPE', name: 'COMBI+ 2.2 E', slug: 'combi-2-2-e-2', swopNo: 499008, swopUrl: 'swop-combi-2-2-e', breakpoint: null, taps: 'front,flex,nordic,fusion,cl-nordic,cl-fusion' },
                { identifier: 'RPB', name: 'COMBI+ 2.2 B', slug: null, swopNo: null, swopUrl: null, breakpoint: null, taps: 'front,flex,nordic,fusion' }
                // NEW END
                // Servicekit 55020 + 10005 passer på alle combier (stort + lille servicekit), som IKKE er NEW INLET
                // Servicekit 10000 passer på alle PRO3 + PRO7, som IKKE er NEW INLET
                // På widget skal alle combier linke til det store servicekit
                // breakpoint null = all new inlet for at sikre der ikke bliver bestilt servicekit til en NEW INLET
            ]
        }
    },
    mounted () {
        const userLang = navigator.language || navigator.userLanguage
        if (userLang && userLang.startsWith('da')) {
            this.showDanishAlert = true
        }
        Bugsnag.start({
            apiKey: 'fb2377299cc33e6414f0205412393375',
            plugins: [new BugsnagPluginVue()]
        })
        this.$store.state.form.cube.own = false
        /* var inputElm = document.getElementById('dawa-autocomplete-input')
        window.dawaAutocomplete.dawaAutocomplete(inputElm, {
            select: (selected) => {
                // console.log('Valgt adresse: ' + selected.tekst)
                this.$store.state.form.contact.validatedAddress = selected.tekst
                this.$store.state.form.contact.address = selected.tekst
            }
        }) */
        let randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000)
        this.$store.state.form.meta.id = 'QSF-' + randomNumber
        this.$store.state.form.cube.own = false
        setInterval(() => {
            if (this.currentStep === 1) {
                this.validateSerial()
            }
        }, 500)
    },
    methods: {
        goToDanishForm () {
            location.href = '/'
        },
        resetAddress () {
            this.$store.state.form.contact.validatedAddress = null
            this.$store.state.form.contact.address = null
        },
        validateFaucet (faucet) {
            if (faucet.type === 'nordic') {
                this.showNordicChooser = true
            } else {
                this.$store.state.form.faucet.meta = null
            }
            this.$store.state.form.validatedFaucet = faucet
        },
        chooseNordic (type) {
            this.$store.state.form.faucet.meta = type
            this.showNordicChooser = false
        },
        validateSerial () {
            function compare (a, b) {
                if (a.identifier > b.identifier) {
                    return -1
                }
                if (a.identifier < b.identifier) {
                    return 1
                }
                return 0
            }

            // Set input variable from input field value
            let input = this.$store.state.form.container.serial
            if (input !== null) {
                input = input.toUpperCase()
            }
            // let filter = /(\d+)/g
            // let formattedInput = input.match(filter)
            // let lastChar = input.substr(input.length - 1)

            // Sort array to ensure best match comes first (Z-A)
            this.serials.sort(compare)

            // clear validatedContainer
            this.$store.state.form.validatedContainer = null

            if (input !== null) {
                if (input.startsWith('Q')) {
                    this.faucetSerial = true
                } else {
                    this.faucetSerial = false
                }
                this.serials.every((serial) => {
                    if (input.match('^' + serial.identifier)) {
                        this.$store.state.form.validatedContainer = serial
                        /* if (serial.servicekitNo) {
                            if (formattedInput.toString().length < 8) {
                                if (serial.breakpoint) {
                                    if (formattedInput < serial.breakpoint) {
                                        showServicekit(serial.servicekitUrl)
                                    } else {
                                        showSwop(serial.swopUrl)
                                    }
                                } else {
                                    showServicekit(serial.servicekitUrl)
                                }
                            } else {
                                if (lastChar === '0') {
                                    showServicekit(serial.servicekitUrl)
                                } else {
                                    showSwop(serial.swopUrl)
                                }
                            }
                        } else {
                            showSwop(serial.swopUrl)
                        } */
                        return false
                    }
                    return true
                })
            }
        },
        submitForm () {
            if (this.$store.state.form.meta.id === null || this.$store.state.form.meta.id === '') {
                let randomNumber = Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000)
                this.$store.state.form.meta.id = 'QSF-' + randomNumber
            }
            this.loading = true
            /*eslint-disable */
            let Email = { send: function (a) { return new Promise(function (n, e) { a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send"; var t = JSON.stringify(a); Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) { n(e) }) }) }, ajaxPost: function (e, n, t) { var a = Email.createCORSRequest("POST", e); a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () { var e = a.responseText; null != t && t(e) }, a.send(n) }, ajax: function (e, n) { var t = Email.createCORSRequest("GET", e); t.onload = function () { var e = t.responseText; null != n && n(e) }, t.send() }, createCORSRequest: function (e, n) { var t = new XMLHttpRequest; return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest).open(e, n) : t = null, t } }
            /*eslint-enable */

            let emailElement = document.getElementById('emailMockup').innerHTML
            let quookerEmail = emailElement

            let formData = new FormData()
            formData.append('email', this.$store.state.form.contact.email)
            formData.append('country', 'NO')
            formData.append('html', quookerEmail)
            formData.append('customer_name', this.$store.state.form.contact.firstname + ' ' + this.$store.state.form.contact.lastname)
            formData.append('form_meta_id', this.$store.state.form.meta.id)
            axios.post('https://serviceformapi.qservice.shop/api/submit-form', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                this.loading = false
                this.currentStep = 8
            })
            .catch((err) => {
                console.log(err)
                alert('Der skete en fejl ved indsendelse af formularen. Prøv venligst igen eller kontakt os hvis problemet fortsætter.')
                this.loading = false
            })
        }
    },
    computed: {
        showEmailChooser () {
            let url = location.href
            if (url.includes('localhost') || url.includes('test')) {
                return true
            } else {
                return false
            }
        },
        sortedFaucets () {
            if (this.$store.state.form.validatedContainer !== null) {
                let arr = []
                this.faucets.forEach((faucet) => {
                    if (this.$store.state.form.validatedContainer.taps.includes(faucet.type)) {
                        arr.push(faucet)
                    }
                })
                return arr
            }
        },
        sortedSurfaces () {
            if (this.$store.state.form.validatedFaucet !== null) {
                let arr = []
                this.surfaces.forEach((surface) => {
                    if (surface.fits.includes(this.$store.state.form.validatedFaucet.type)) {
                        arr.push(surface)
                    }
                })
                return arr
            }
        },
        formattedEmailBody () {
            let body = {
                personalizations: [
                    {
                        to: [
                            {
                                email: 'nr@deveo.dk',
                                name: 'Nicolai Ramsby'
                            }
                        ],
                        subject: 'Hello, World!'
                    }
                ],
                content: [
                    {
                        type: 'text/plain',
                        value: 'Heya!'
                    }
                ],
                from: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                },
                reply_to: {
                    email: 'nr@deveo.dk',
                    name: 'Nicolai Ramsby'
                }
            }
            return body
        },
        years () {
            let currentYear = new Date().getFullYear()
            let years = []
            let startYear = 2004

            while (startYear <= currentYear) {
                years.push(startYear++)
            }

            return years
        },
        fullAddress () {
            return this.address + ', ' + this.zipcode + ' ' + this.city
        }
    },
    components: {
        ValidationMessages,
        FileUpload
    },
    validations: {
        address: {
            required
        },
        zipcode: {
            required
        },
        city: {
            required
        },
        $store: {
            state: {
                form: {
                    problem: {
                        description: {
                            required,
                            minLength: minLength(20),
                            maxLength: maxLength(1000)
                        }
                    },
                    contact: {
                        firstname: {
                            required,
                            minLength: minLength(2)
                        },
                        lastname: {
                            required,
                            minLength: minLength(2)
                        },
                        email: {
                            required,
                            email
                        },
                        phone: {
                            required
                        }
                    }
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// norway.vue?0ae21149